import {
  FaCode,
  FaLaptopCode,
  FaMobileAlt,
  FaCloud,
  FaPaintBrush,
  FaTools,
  FaCheckCircle,
  FaUsers,
  FaRocket,
  FaShieldAlt,
  FaClock,
  FaChartLine,
  FaUserTie,
  FaServer,
  FaPenNib,
  FaTasks,
  FaHeadset,
  FaGraduationCap,
  FaShoppingCart,
  FaHospital,
  FaUniversity,
  FaGamepad,
  FaClipboardCheck,
  FaDatabase,
  FaUtensils,
  FaCashRegister,
  FaHotel,
  FaBook,
  FaTshirt
  
} from 'react-icons/fa';

export const company = {
  name: 'ZuelonX It Solution',
  email: 'zuelonX@gmail.com',
  phone: '+94 711922350',
  location: 'jaffna, Sri Lanka'
};

export const services = [
  {
    icon: FaCode,
    title: 'Custom Software Development',
    description:
      'We build tailored software solutions designed around your unique business processes, goals, and growth plans.'
  },
  {
    icon: FaLaptopCode,
    title: 'Web Development',
    description:
      'Modern, high-performance websites and web applications with responsive layouts and excellent user experience.'
  },
  {
    icon: FaMobileAlt,
    title: 'Mobile App Development',
    description:
      'Android and iOS applications that are fast, secure, scalable, and built for real-world business needs.'
  },
  {
    icon: FaCloud,
    title: 'SaaS & Cloud Solutions',
    description:
      'Scalable SaaS products and cloud-based systems that support subscriptions, automation, and remote access.'
  },
  {
     icon: FaGamepad,
    title: 'Game Development',
    description:
      'Immersive and interactive game experiences with stunning visuals, smooth gameplay, and cross-platform performance.'
  },
  {
    icon: FaTools,
    title: 'Maintenance & Support',
    description:
      'Continuous updates, bug fixes, performance optimization, and long-term support for your digital products.'
  }
];

export const features = [
  {
    icon: FaUsers,
    title: 'Expert Team',
    description:
      'Skilled developers, designers, and strategists working together on every project.'
  },
  {
    icon: FaRocket,
    title: 'Fast Delivery',
    description:
      'Efficient development process that helps launch products on time without compromising quality.'
  },
  {
    icon: FaShieldAlt,
    title: 'Reliable Solutions',
    description:
      'We prioritize performance, security, stability, and clean architecture in every build.'
  },
  {
    icon: FaClock,
    title: 'Dedicated Support',
    description:
      'We stay with you after launch to monitor, improve, and support your system.'
  },
  {
    icon: FaChartLine,
    title: 'Scalable Growth',
    description:
      'Solutions built to support future users, features, and business expansion.'
  },
  {
    icon: FaCheckCircle,
    title: 'Client-Focused Approach',
    description:
      'We listen, plan, and build based on your business goals and user expectations.'
  }
];

export const team = [
  {
    icon: FaUserTie,
    name: 'A. Kalainilavan',
    role: 'Founder',
    description:
      'Provides strategic leadership and drives the company vision by delivering innovative digital solutions and building long-term client relationships.'
  },

  {
    icon: FaServer,
    name: 'T. Kajagoban',
    role: 'Co-Founder & CEO',
    description:
      'Leads the company’s technical operations, oversees software architecture, and ensures scalable and reliable business solutions.'
  },

  {
    icon: FaClipboardCheck,
    name: 'P. Hisanth',
    role: 'Project Coordinator',
    description:
      'Manages project workflows, coordinates team activities, and ensures timely delivery of high-quality software projects.'
  },

  {
    icon: FaLaptopCode,
    name: 'K. Sharunitha',
    role: 'Senior Full-Stack Developer & HR',
    description:
      'Develops modern web applications with responsive interfaces, powerful backend systems, and seamless user experiences.'
  },

  {
    icon: FaDatabase,
    name: 'M. Vijinthan',
    role: 'Senior Backend Developer',
    description:
      'Builds secure APIs, manages databases, and develops scalable backend infrastructures for enterprise-level applications.'
  },

  {
    icon: FaMobileAlt,
    name: 'S.Ankavan',
    role: 'Senior Mobile App Developer',
    description:
      'Designs and develops high-performance Android and iOS applications with smooth functionality and optimized user experience.'
  }
];

export const portfolio = [
  {
    icon: FaUtensils,
    title: 'Restaurant Management System',
    description:
      'Smart restaurant software with POS, kitchen tracking, online reservations, billing, and analytics.'
  },
  {
    icon: FaCashRegister,
    title: 'Restaurant POS System',
    description:
      'Fast billing and cashier system with inventory tracking, table management, and real-time order updates.'
  },
  {
    icon: FaHotel,
    title: 'Hotel Management System',
    description:
      'Complete hotel solution with room booking, guest management, invoices, housekeeping, and reports.'
  },
  {
    icon: FaBook,
    title: 'Bookstore Management System',
    description:
      'Book inventory, customer orders, supplier management, billing, and low-stock monitoring system.'
  },
  {
    icon: FaTshirt,
    title: 'Clothing Store Platform',
    description:
      'Fashion e-commerce platform with product catalogs, order tracking, payments, and customer dashboards.'
  },
  {
    icon: FaMobileAlt,
    title: 'Mobile App Solutions',
    description:
      'Modern Android and iOS applications with real-time sync, notifications, dashboards, and analytics.'
  }
];

export const testimonials = [
  {
    name: 'Ahamed Riffath',
    company: 'BrightEdu Academy',
    message:
      'ZuelonX It Solutions delivered our platform professionally and on time. Their team understood our needs clearly and built exactly what we wanted.'
  },
  {
    name: 'Shehani De Mel',
    company: 'UrbanMart',
    message:
      'Excellent communication, clean design, and smooth development process. We are very happy with the final product.'
  },
  {
    name: 'Pradeep Senanayake',
    company: 'CarePlus Medical',
    message:
      'A reliable software team that focuses on quality and support. They helped us improve operations with a custom system.'
  },
  {
    name: 'Nimal Perera',
    company: 'NextGen Holdings',
    message:
      'Their creative approach and technical expertise helped our business grow faster than expected.'
  },
  {
    name: 'Fathima Nazeera',
    company: 'Lanka Fashion Hub',
    message:
      'Beautiful UI design and excellent customer support throughout the project development.'
  },
  {
    name: 'Kasun Madushanka',
    company: 'SkyTech Solutions',
    message:
      'They delivered a fast and secure web application that exceeded our expectations.'
  },
  {
    name: 'Dilani Fernando',
    company: 'EduSmart Institute',
    message:
      'Professional team with strong attention to detail. Highly recommended for software projects.'
  },
  {
    name: 'Rizwan Ahamed',
    company: 'QuickMart',
    message:
      'The development process was smooth and transparent. Communication was excellent from start to finish.'
  },
  {
    name: 'Sachini Jayawardena',
    company: 'Nova Events',
    message:
      'Their team created a stunning website for our business with modern animations and responsive design.'
  },
  {
    name: 'Mihiranga Silva',
    company: 'TravelEase Lanka',
    message:
      'Very impressed with their professionalism and ability to deliver quality solutions on time.'
  },
  {
    name: 'Tharushi Peris',
    company: 'HealthCare Plus',
    message:
      'Amazing experience working with them. The final system improved our workflow significantly.'
  },
  {
    name: 'Hassan Imran',
    company: 'Digital Wave',
    message:
      'Creative ideas, smooth animations, and strong technical support made this project successful.'
  }
];